import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { TokenInfo } from '@/types/token';
import { FC } from 'react';
import './index.less';

export interface BlastBalanceInfo {
  token: TokenInfo;
  balance: WrappedBigNumber;
}

interface IPropTypes {
  balances: BlastBalanceInfo[];
}

const BlastWithdrawForm: FC<IPropTypes> = ({ balances }) => {
  return (
    <div className="syn-blast-withdraw-form">
      <div className="syn-blast-withdraw-title">Withdraw Blast Account Balance</div>
      <div className="syn-blast-withdraw-desc">
        The SynFutures dApp on the Blast network has been retired. Please withdraw all tokens from your account as soon
        as possible.
      </div>
      <div className="syn-blast-withdraw-list">
        <div className="syn-blast-withdraw-list-title">Your account balance on Blast:</div>
        <div className="syn-blast-withdraw-items">
          {balances.map((item, index) => (
            <div key={item.token.address} className="syn-blast-withdraw-item">
              {item.balance.formatNumberWithTooltip({ suffix: item.token.symbol, isShowTBMK: true })}
              {index < balances.length - 1 && ', '}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlastWithdrawForm;
